<template>
    <c-dialog ref="dialog" title="维修记录详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.document_number" class="m-detail-tag flex-center-cross">
                <label>{{detailData.document_number}}</label>
            </div>
        </template>

        <div class="m-detail-box">
            <c-title>资产信息</c-title>
            <c-detail column="2">
                <c-detail-item label="资产编码">{{detailData.asset_code}}</c-detail-item>
                <c-detail-item label="资产名称">{{detailData.asset_name}}</c-detail-item>
                <c-detail-item label="资产分类">{{detailData.asset_category}}</c-detail-item>
                <c-detail-item label="单位">{{detailData.unit || '-'}}</c-detail-item>
                <c-detail-item label="所属网点">{{detailData.outlet_name}}</c-detail-item>
            </c-detail>

            <c-title>维修信息</c-title>
            <c-detail column="2">
                <c-detail-item label="维修类型">{{detailData.repair_type==1?'出现故障现象':'维修更换部件'}}</c-detail-item>
                <c-detail-item label="维修状态">
                    <c-state dict="repairStatusDic" :value="detailData.status"></c-state>
                </c-detail-item>
                <c-detail-item label="送修人">{{detailData.sender_user_name || '-'}}</c-detail-item>
                <c-detail-item label="送修时间">{{detailData.repair_time || '-'}}</c-detail-item>
                <c-detail-item label="故障描述" colspan="2">{{detailData.repair_summary || '-'}}</c-detail-item>
                <c-detail-item label="备注" colspan="2">{{detailData.remark || '-'}}</c-detail-item>

                <c-detail-item v-if="detailData.status==2" label="维修时间">{{detailData.finish_repair_time || '-'}}</c-detail-item>
                <c-detail-item v-if="detailData.status==2" label="维修说明" colspan="2">{{detailData.finish_repair_remark || '-'}}</c-detail-item>
            </c-detail>

            <c-title>其他信息</c-title>
            <c-detail column="2">
                <c-detail-item label="创建人">{{detailData.create_user_name || '-'}}</c-detail-item>
                <c-detail-item label="创建时间">{{detailData.create_date || '-'}}</c-detail-item>
                <c-detail-item label="修改人">{{detailData.update_user_name || '-'}}</c-detail-item>
                <c-detail-item label="修改时间">{{detailData.update_date || '-'}}</c-detail-item>
            </c-detail>
        </div>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex';
export default {
    name: 'assetRepairRecordDetail',
    props: {
        id: [String, Number]
    },
    computed: {
        ...mapState(['repairStatusDic'])
    },
    data() {
        return {
            detailData: {}
        }
    },
    methods: {
        open() {
            this.request({
                url: '/asset_repair_record/detail',
                data: {id: this.id},
                loading: true,
                success: data => {
                    this.detailData = data;
                    this.$refs.dialog.open();
                }
            });
        }
    }
}
</script>
